import React from 'react';
import { Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

import Chart from './Chart';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const NoData = () => <p>{<FormattedMessage id="professorStatistics.NoDataMessage" />}</p>;


export default class AcademicYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [...this.props.data],
        };
        this.activateShowMode = this.activateShowMode.bind(this);
    }


    activateShowMode() {
        this.setState({ showPreviousYear: !this.state.showPreviousYear });
    }


    render() {
        const { data } = this.state;
        return (
            <div>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {this.props.headerText}{<FormattedMessage id="professorStatistics.academicYearHeader" />}
                        </Header>

                    </Segment>

                    {data.length ? <Segment>
                        <Header as="h3">{<FormattedMessage id="professorStatistics.tableShow" />}</Header>

                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        {<FormattedMessage id="professorInputGrades.course" />}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {<FormattedMessage id="professorStatistics.numberOfStudents" />}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {<FormattedMessage id="professorStatistics.averrageGrade" />}
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body> {data.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseImplementationName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.numberOfStudents}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.averageGrade}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>  </Segment>
                        : <Segment><NoData /></Segment>

                    }

                    {data.length ? <Chart
                        data={data}
                    />
                        : <div />
                    }

                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/StatisticsForProfessor/AcademicYear.js